import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { sendCustomSentryBreadcrumb, setSentryError } from '@helpers/sentry';

import { AnalyticsType } from '@interfaces/analytics';
import { getCatchErrorMessage } from '@helpers/error';
import {
  getErrorNotification,
  useNotification,
} from '@components/Notification';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';

const useScreenShare = () => {
  const { t: translate } = useTranslation();

  const { showNotification } = useNotification();

  const { currentParticipant, trackEventAnalytics } = useMytaverseEvent();

  const { startScreenSharing, stopScreenSharing, isSharingScreen } =
    useCommunications();

  return useCallback(async () => {
    try {
      trackEventAnalytics(AnalyticsType.NavbarButtonClick, {
        name: 'screen-sharing',
      });

      if (isSharingScreen) {
        sendCustomSentryBreadcrumb({ message: 'Stop zoom share screen' });
        console.log('Stop zoom share screen');
        await stopScreenSharing();
        trackEventAnalytics(AnalyticsType.ScreenShareFinish, {
          region: currentParticipant?.region?.region,
          isPrivate: currentParticipant?.region?.isSeatRegion || false,
        });
      } else {
        sendCustomSentryBreadcrumb({ message: 'Start zoom share screen' });
        console.log('Start zoom share screen');
        await startScreenSharing();
        trackEventAnalytics(AnalyticsType.ScreenShareStart, {
          region: currentParticipant?.region?.region,
          isPrivate: currentParticipant?.region?.isSeatRegion || false,
        });
      }
    } catch (error: unknown) {
      console.log(getCatchErrorMessage(error));
      setSentryError(error);
      showNotification(
        getErrorNotification({
          message: translate('notifications.video.sharing.stopped'),
        }),
      );
    }
  }, [
    isSharingScreen,
    trackEventAnalytics,
    startScreenSharing,
    stopScreenSharing,
    sendCustomSentryBreadcrumb,
    currentParticipant,
  ]);
};

export default useScreenShare;
